import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ItemMeetingInfo = ({ labelKey, content, customComponent, isCenter, isLink }) => {
    const { t } = useTranslation();

    return (
        <Grid container columnSpacing={3} sx={{ alignItems: isCenter && 'center' }}>
            <Grid item xs={12} md={3} lg={3} xl={2.5}>
                <Typography
                    fontWeight={550}
                    textAlign={'end'}
                    sx={{ color: (theme) => theme.palette.text[700] }}
                >
                    {t(labelKey)}
                </Typography>
            </Grid>
            <Grid
                item
                xs={12}
                md={9}
                lg={9}
                xl={9.5}
                sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre-wrap ' }}
            >
                <Typography fontWeight={600} sx={{ color: theme => isLink ? theme.palette.primary.main : theme.palette.text[700] }}>{content ?? '---'}</Typography>
                {customComponent}
            </Grid>
        </Grid>
    );
};

export default ItemMeetingInfo;
